import RelationsTable from 'components/RelationsTable';
import useEntities from 'hooks/useEntities';
import useOrganization from 'hooks/useOrganization';
import { entityColumnsToAntColumns } from 'utils/entityColumnsToAntColumns';

const GameDisciplinary = ({ sourceEntityId, data, competitionId, onChange }) => {
    const entities = useEntities();
    const sourceEntity = entities.Game;
    const targetEntity = entities.Disciplinary;
    const { orgNavigate } = useOrganization();

    return (
        <div>
            <RelationsTable
                addButton={{
                    label: 'Create disciplinary',
                    onClick: () => orgNavigate(`/disciplinaries/_new_?gameId=${sourceEntityId}&competitionId=${competitionId}`),
                }}
                data={data}
                columns={entityColumnsToAntColumns(targetEntity, [
                    'Game',
                    'subject',
                    'Players',
                    'status',
                ])}
                sourceEntity={sourceEntity}
                targetEntity={targetEntity}
                emptyMessage={`This ${sourceEntity.displayName} does not have any ${targetEntity.displayNamePlural}`}
            />
        </div>
    )
}

export default GameDisciplinary
